module.exports = __webpack_public_path__ + "static/media/etc.ccaf6601.svg";